module.exports = __webpack_public_path__ + "7e4b29ba/img/mini-logo.18817ee5.svg";